var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PreviousPage"},[_c('div',{staticClass:"back"},[_c('router-link',{staticClass:"button full",attrs:{"to":{name: 'Blog'}}},[_vm._v("Retour à la liste des articles")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }